module.exports = __webpack_public_path__ + "static/media/ascentarc-4.4b3bb83c.jpg";